import React from 'react';
import { GenericModelTable } from '../components';

const rateColumn = (name, label) => ({
	name,
	label,
	options: {
		sort: true,
		filter: false,
		searchable: false
	}
});

const columns = [
	{
		name: 'effectiveDate',
		label: 'Effective From',
		options: {
			sort: true,
			filter: false,
			searchable: false
		}
	},
	rateColumn('gold18', 'Gold 18K'),
	rateColumn('gold21', 'Gold 21K'),
	rateColumn('gold24', 'Gold 24K'),
	rateColumn('jewelry', 'Diamond Jewelry')
];
const modelName = 'dailyrate';

function Dailyrates() {
	const tableOptions = {
		modelName,
		modelNamePlural: 'Daily Rates',
		columns
	};
	return <GenericModelTable {...tableOptions} />;
}

export default Dailyrates;
